import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";

import { useUrlHistory } from "../../modules/Common/UrlHistoryContext";
import HNSColors from "../../ui library/HNSColors";

const GoBackButton = ({ id = "", prevUrlDefault = "/search", forcePrevURLDefault = false }) => {
  const { goBack, history = [] } = useUrlHistory();
  const navigate = useNavigate();

  const handleBack = () => {
    if (goBack && history.length > 1 && !forcePrevURLDefault) {
      const navigated = goBack();
      if (navigated) {
        return;
      }
    }

    if (prevUrlDefault) {
      navigate(prevUrlDefault, { replace: true });
      return;
    }

    window.history.back();
  };

  return (
    <IconButton
      onClick={handleBack}
      id={`go-back-button-${id}`}
      sx={{
        color: HNSColors.primary[400],
        "&:hover": { backgroundColor: "rgba(0,0,0,0.04)" },
        mb: 1,
        borderRadius: "8px",
      }}
    >
      <ArrowBackIosIcon fontSize="small" />
      <Typography
        style={{
          fontSize: "0.8rem",
        }}
      >
        Go Back
      </Typography>
    </IconButton>
  );
};

export default GoBackButton;
